"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _index = require("../../../../index");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var GroupConditions = /*#__PURE__*/function (_React$Component) {
  _inherits(GroupConditions, _React$Component);

  function GroupConditions() {
    _classCallCheck(this, GroupConditions);

    return _possibleConstructorReturn(this, _getPrototypeOf(GroupConditions).apply(this, arguments));
  }

  _createClass(GroupConditions, [{
    key: "render",
    value: function render() {
      var formHandler = this.props.formHandler;
      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("p", null, "Conditions"), _react["default"].createElement("div", {
        className: "dark-well"
      }, _react["default"].createElement("p", {
        style: {
          marginBottom: 0
        }
      }, "User registration date"), _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col-md-6"
      }, _react["default"].createElement(_index.InputField, {
        materialProps: {
          fullWidth: true,
          InputLabelProps: {
            shrink: true
          }
        },
        customInput: _TextField["default"],
        label: "Registered from",
        type: "date",
        name: "filter.createdFrom",
        value: formHandler.state.record.filter.createdFrom,
        handler: formHandler
      })), _react["default"].createElement("div", {
        className: "col-md-6"
      }, _react["default"].createElement(_index.InputField, {
        materialProps: {
          fullWidth: true,
          InputLabelProps: {
            shrink: true
          }
        },
        customInput: _TextField["default"],
        label: "Registered to",
        type: "date",
        name: "filter.createdTo",
        value: formHandler.state.record.filter.createdTo,
        handler: formHandler
      }))), _react["default"].createElement("div", {
        className: "text-center",
        style: {
          marginTop: 20
        }
      }, "OR"), _react["default"].createElement("div", {
        className: "text-center",
        style: {
          marginTop: 20
        }
      }, _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col-sm-6",
        style: {
          margin: "auto"
        }
      }, _react["default"].createElement(_index.InputField, {
        materialProps: {
          fullWidth: true,
          InputLabelProps: {
            shrink: true
          }
        },
        customInput: _TextField["default"],
        label: "Registered X days before current date",
        type: "number",
        name: "filter.registeredBefore",
        value: formHandler.state.record.filter.registeredBefore,
        handler: formHandler
      }))))), _react["default"].createElement("div", {
        className: "dark-well"
      }, _react["default"].createElement("p", {
        style: {
          marginBottom: 0
        }
      }, "Last activity date"), _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col-md-6"
      }, _react["default"].createElement(_index.InputField, {
        materialProps: {
          fullWidth: true,
          InputLabelProps: {
            shrink: true
          }
        },
        customInput: _TextField["default"],
        label: "From",
        type: "date",
        name: "filter.lastActivityFrom",
        value: formHandler.state.record.filter.lastActivityFrom,
        handler: formHandler
      })), _react["default"].createElement("div", {
        className: "col-md-6"
      }, _react["default"].createElement(_index.InputField, {
        materialProps: {
          fullWidth: true,
          InputLabelProps: {
            shrink: true
          }
        },
        customInput: _TextField["default"],
        label: "To",
        type: "date",
        name: "filter.lastActivityTo",
        value: formHandler.state.record.filter.lastActivityTo,
        handler: formHandler
      })))), _react["default"].createElement("div", {
        className: "dark-well"
      }, _react["default"].createElement("p", {
        style: {
          marginBottom: 0
        }
      }, "Last transaction date"), _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col-md-6"
      }, _react["default"].createElement(_index.InputField, {
        materialProps: {
          fullWidth: true,
          InputLabelProps: {
            shrink: true
          }
        },
        customInput: _TextField["default"],
        label: "From",
        type: "date",
        name: "filter.lastTransactionFrom",
        value: formHandler.state.record.filter.lastTransactionFrom,
        handler: formHandler
      })), _react["default"].createElement("div", {
        className: "col-md-6"
      }, _react["default"].createElement(_index.InputField, {
        materialProps: {
          fullWidth: true,
          InputLabelProps: {
            shrink: true
          }
        },
        customInput: _TextField["default"],
        label: "To",
        type: "date",
        name: "filter.lastTransactionTo",
        value: formHandler.state.record.filter.lastTransactionTo,
        handler: formHandler
      })))), _react["default"].createElement("div", {
        className: "dark-well"
      }, _react["default"].createElement("p", {
        style: {
          marginBottom: 0
        }
      }, "Balance"), _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col-md-6"
      }, _react["default"].createElement(_index.InputField, {
        materialProps: {
          fullWidth: true,
          InputLabelProps: {
            shrink: true
          }
        },
        customInput: _TextField["default"],
        label: "From",
        type: "number",
        name: "filter.balanceFrom",
        value: formHandler.state.record.filter.balanceFrom,
        handler: formHandler
      })), _react["default"].createElement("div", {
        className: "col-md-6"
      }, _react["default"].createElement(_index.InputField, {
        materialProps: {
          fullWidth: true,
          InputLabelProps: {
            shrink: true
          }
        },
        customInput: _TextField["default"],
        label: "To",
        type: "number",
        name: "filter.balanceTo",
        value: formHandler.state.record.filter.balanceTo,
        handler: formHandler
      })))), _react["default"].createElement("div", {
        className: "dark-well"
      }, _react["default"].createElement("p", {
        style: {
          marginBottom: 0
        }
      }, "Card details"), _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col-md-6"
      }, _react["default"].createElement(_index.AppCheckboxInput, {
        name: "filter.cardNotOrdered",
        value: formHandler.state.record.filter.cardNotOrdered,
        handler: formHandler,
        labelText: "Card not ordered"
      })), _react["default"].createElement("div", {
        className: "col-md-6"
      }, _react["default"].createElement(_index.AppCheckboxInput, {
        name: "filter.cardNotActivated",
        value: formHandler.state.record.filter.cardNotActivated,
        handler: formHandler,
        labelText: "Card Not activated"
      })))));
    }
  }]);

  return GroupConditions;
}(_react["default"].Component);

exports["default"] = GroupConditions;